import withFinalField from 'hocs/withFinalField';

import { DigitInput } from './DigitInput';
export { DigitContainer as Digit } from './DigitContainer';
export { Digits } from './Digits';

export const FFDigitInput = withFinalField(DigitInput);
